export const config = {
  email: "lamnguyen.hcmut@gmail.com",
  linkedIn: "https://linkedin.com/in/lamnguyen-kn97",
  github: "https://github.com/lamnguyenkn97",
  social: {
    facebook: "https://facebook.com/lamnguyenkn97",
    linkedin: "https://linkedin.com/in/lamnguyen-kn97",
    github: "https://github.com/lamnguyenkn97",
  },
  // Resume
  resumeUrl: process.env.REACT_APP_RESUME_URL || "/Lam_Nguyen_CV.html",
};
